import React, { memo, useState } from "react";
import "./BlogSidebar.css";

const ALL_CATEGORIES = "3,4,5";

function BlogSidebar({ categoriesList = [], totalResult = 0, onChangeCategories }) {
  const [activeCategory, setActiveCategory] = useState(ALL_CATEGORIES);

  const handleFilter = (categoryId) => {
    setActiveCategory(categoryId);
    onChangeCategories(categoryId);
  };

  return (
    <aside className="sidebar-wrapper">
      
      <div className="sidebar-search-box">
        <span className="results-count">
          {totalResult} results found
        </span>
        <hr />
      </div>

      
      <div className="single-sidebar">
        <h4 className="filter-title">Filter by Category</h4>

        <div className="category-filter">
          <button
            type="button"
            className={`filter-btn ${activeCategory === ALL_CATEGORIES ? "active" : ""}`}
            onClick={() => handleFilter(ALL_CATEGORIES)}
          >
            All
          </button>

          {categoriesList.map((category) => (
            <button
              key={category.id}
              type="button"
              className={`filter-btn ${activeCategory === category.id ? "active" : ""}`}
              onClick={() => handleFilter(category.id)} 
            >
              {category.name}
              <span className="count">{category.count}</span>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}

export default memo(BlogSidebar);
